<div class="step-pricing" *transloco="let t" data-testid="wizard-step-pricing">
  <p-card>
    <ng-template #header>
      <div class="card-header">
        <i class="pi pi-bolt header-icon"></i>
        <h2 class="header-title">{{ t('objects.wizard.pricing.title') }}</h2>
      </div>
    </ng-template>

    <form [formGroup]="form" class="card-content">
      <app-wizard-step-hint
        icon="pi pi-calendar"
        [text]="t('positioning.wizard.pricing')" />

      <!-- Two columns: Electricity & Pets -->
      <div class="policies-row">
        <!-- Electricity Policy -->
        <div class="policy-box" data-testid="wizard-pricing-electricity">
          <div class="policy-header">
            <i class="pi pi-bolt"></i>
            <span>{{ t('objects.wizard.pricing.electricity') }}</span>
          </div>
          <div class="radio-group">
            @for (option of electricityOptions(); track option.value) {
              <div class="radio-option"
                   [class.selected]="form.get('electricityPolicy')?.value === option.value"
                   (click)="form.get('electricityPolicy')?.setValue(option.value)">
                <p-radiobutton
                  [inputId]="'electricity-' + option.value"
                  formControlName="electricityPolicy"
                  [value]="option.value"
                />
                <label [for]="'electricity-' + option.value" class="radio-label">
                  {{ option.label }}
                </label>
              </div>
            }
          </div>
        </div>

        <!-- Pet Policy -->
        <div class="policy-box" data-testid="wizard-pricing-pets">
          <div class="policy-header">
            <i class="pi pi-github"></i>
            <span>{{ t('objects.wizard.pricing.pets') }}</span>
          </div>
          <p-select
            data-testid="wizard-pricing-pet-select"
            [options]="petSelectOptions()"
            formControlName="petPolicy"
            [fluid]="true"
            [placeholder]="t('objects.wizard.pricing.petSelectPlaceholder')"
          />

          @if (showPetFee) {
            <div class="pet-fee-field">
              <label class="field-label">{{ petFeeLabel }}</label>
              <p-inputnumber
                data-testid="wizard-pricing-pet-fee"
                inputId="petFee"
                formControlName="petFee"
                [min]="1"
                [fluid]="true"
              />
              @if (getErrorMessage('petFee'); as error) {
                <small class="field-error">{{ error }}</small>
              }
            </div>
          }
        </div>
      </div>

      <!-- Additional Fees -->
      <div class="fees-section">
        <h3 class="section-title">{{ t('objects.wizard.pricing.otherFees') }}</h3>
        <div class="fees-row">
          <div class="form-group">
            <label class="field-label">{{ t('objects.wizard.pricing.deposit') }}</label>
            <p-inputnumber
              data-testid="wizard-pricing-deposit"
              inputId="depositPercentage"
              formControlName="depositPercentage"
              [min]="0"
              [max]="100"
              [fluid]="true"
            />
            @if (getErrorMessage('depositPercentage'); as error) {
              <small class="field-error">{{ error }}</small>
            }
          </div>

          <div class="form-group">
            <label class="field-label">{{ t('objects.wizard.pricing.depositPaymentDays') }}</label>
            <p-inputnumber
              data-testid="wizard-pricing-deposit-days"
              inputId="depositPaymentDays"
              formControlName="depositPaymentDays"
              [min]="1"
              [max]="30"
              [fluid]="true"
            />
            <small class="field-hint">{{ t('objects.wizard.pricing.depositPaymentDaysHint') }}</small>
            @if (getErrorMessage('depositPaymentDays'); as error) {
              <small class="field-error">{{ error }}</small>
            }
          </div>

          <div class="form-group">
            <label class="field-label">{{ t('objects.wizard.pricing.cleaningFee') }}</label>
            <p-inputnumber
              data-testid="wizard-pricing-cleaning-fee"
              inputId="cleaningFee"
              formControlName="cleaningFee"
              [min]="0"
              [fluid]="true"
            />
          </div>

          <div class="form-group">
            <label class="field-label">{{ t('objects.wizard.pricing.checkInTime') }}</label>
            <p-datepicker
              data-testid="wizard-pricing-check-in-time"
              inputId="checkInTime"
              formControlName="checkInTime"
              dataType="string"
              [timeOnly]="true"
              [showIcon]="true"
              icon="pi pi-clock"
              [stepMinute]="15"
              [fluid]="true"
              appendTo="body"
            />
            <small class="field-hint">{{ t('objects.wizard.pricing.checkInTimeHint') }}</small>
            @if (getErrorMessage('checkInTime'); as error) {
              <small class="field-error">{{ error }}</small>
            }
          </div>

          <div class="form-group">
            <label class="field-label">{{ t('objects.wizard.pricing.checkOutTime') }}</label>
            <p-datepicker
              data-testid="wizard-pricing-check-out-time"
              inputId="checkOutTime"
              formControlName="checkOutTime"
              dataType="string"
              [timeOnly]="true"
              [showIcon]="true"
              icon="pi pi-clock"
              [stepMinute]="15"
              [fluid]="true"
              appendTo="body"
            />
            <small class="field-hint">{{ t('objects.wizard.pricing.checkOutTimeHint') }}</small>
            @if (getErrorMessage('checkOutTime'); as error) {
              <small class="field-error">{{ error }}</small>
            }
          </div>
        </div>
      </div>

      <!-- Season Pricing -->
      <app-season-pricing />
    </form>

    @if (!isViewMode()) {
      <ng-template #footer>
        <div class="card-footer">
          <p-button
            data-testid="wizard-pricing-back-btn"
            [label]="t('objects.wizard.footer.back')"
            severity="secondary"
            [text]="true"
            (onClick)="onPrevious()"
          />
          <p-button
            data-testid="wizard-pricing-submit-btn"
            [label]="t('objects.wizard.footer.saveAndPreview')"
            icon="pi pi-chevron-right"
            iconPos="right"
            [disabled]="!canSubmit() || isSubmitting()"
            [loading]="isSubmitting()"
            (onClick)="onSubmit()"
          />
        </div>
      </ng-template>
    }
  </p-card>
</div>
